import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Loader from "./components/Spin/Loader";
import "antd/dist/antd.css";
import store from "./store";
import {Provider} from "react-redux";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
